import { render, staticRenderFns } from "./appList.vue?vue&type=template&id=35e22c16&scoped=true&"
import script from "./appList.vue?vue&type=script&lang=js&"
export * from "./appList.vue?vue&type=script&lang=js&"
import style0 from "./appList.vue?vue&type=style&index=0&id=35e22c16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e22c16",
  null
  
)

export default component.exports